import React, { useEffect, useRef, useState } from "react";
import "./Navbar.css";

// Nếu bạn dùng react-router-dom thì đổi <a> thành <NavLink> cho đẹp
// import { NavLink } from "react-router-dom";

const NAV = [
  { label: "Home", href: "/" },
  {
    label: "Cu Chi Tunnels",
    href: "/travel",
    children: [
      { label: "Half Day Tour", href: "/cu-chi-tunnels/half-day" },
      { label: "Full Day Tour", href: "/cu-chi-tunnels/full-day" },
    ],
  },
  {
    label: "Mekong Delta",
    href: "/travel",
    children: [
      { label: "1 Day Tour", href: "/mekong-delta/1-day" },
      { label: "2 Days 1 Night", href: "/mekong-delta/2d1n" },
    ],
  },
  { label: "Chính sách bảo mật", href: "/privacysiam" },
  {
    label: "Visa",
    href: "/travel",
    children: [
      { label: "Vietnam E-Visa", href: "/visa/e-visa" },
      { label: "Visa Extension", href: "/visa/extension" },
    ],
  },
  {
    label: "Other Tours",
    href: "/travel",
    children: [
      { label: "City Tour", href: "/other-tours/city-tour" },
      { label: "Food Tour", href: "/other-tours/food-tour" },
    ],
  },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const wrapRef = useRef(null);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (!wrapRef.current) return;
      if (!wrapRef.current.contains(e.target)) {
        setOpenDropdown(null);
        setMobileOpen(false);
      }
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  useEffect(() => {
    const onEsc = (e) => {
      if (e.key === "Escape") {
        setOpenDropdown(null);
        setMobileOpen(false);
      }
    };
    document.addEventListener("keydown", onEsc);
    return () => document.removeEventListener("keydown", onEsc);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [mobileOpen]);

  const toggleDropdown = (key) => {
    setOpenDropdown((prev) => (prev === key ? null : key));
  };

  return (
    <header className="st-header" ref={wrapRef}>
      <div className="st-inner">
        {/* LEFT: Logo */}
        <a className="st-logo" href="/travel">
          <img style={{width:'80px', height:'auto'}} src="/logo.png" alt="" />
        </a>

        {/* CENTER: Nav (desktop) */}
        <nav className="st-nav" aria-label="Main navigation">
          <ul className="st-menu">
            {NAV.map((item) => {
              const hasChildren = !!item.children?.length;
              const key = item.label;

              return (
                <li
                  key={key}
                  className={`st-item ${hasChildren ? "hasChildren" : ""}`}
                  onMouseLeave={() => setOpenDropdown(null)}
                >
                  <button
                    className={`st-link ${openDropdown === key ? "active" : ""}`}
                    type="button"
                    onMouseEnter={() => hasChildren && setOpenDropdown(key)}
                    onClick={() => (hasChildren ? toggleDropdown(key) : (window.location.href = item.href))}
                    aria-haspopup={hasChildren ? "menu" : undefined}
                    aria-expanded={hasChildren ? openDropdown === key : undefined}
                  >
                    {item.label}
                    {hasChildren && <span className="st-caret" aria-hidden="true">▾</span>}
                  </button>

                  {hasChildren && openDropdown === key && (
                    <div className="st-dropdown" role="menu">
                      {item.children.map((c) => (
                        <a key={c.href} className="st-ddLink" href={c.href} role="menuitem">
                          {c.label}
                        </a>
                      ))}
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        </nav>

        {/* RIGHT: icons */}
        <div className="st-actions">
          <a className="st-iconBtn" href="/cart" aria-label="Cart">
            🛒
          </a>

          <button
            className="st-iconBtn st-burger"
            type="button"
            aria-label="Open menu"
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen((v) => !v)}
          >
            ☰
          </button>
        </div>
      </div>

      {/* MOBILE DRAWER */}
      <div className={`st-mobile ${mobileOpen ? "open" : ""}`} aria-hidden={!mobileOpen}>
        <div className="st-mobilePanel" role="dialog" aria-label="Mobile menu">
          <div className="st-mobileTop">
            <span className="st-mobileTitle">Menu</span>
            <button className="st-close" type="button" onClick={() => setMobileOpen(false)} aria-label="Close menu">
              ✕
            </button>
          </div>

          <div className="st-mobileList">
            {NAV.map((item) => {
              const hasChildren = !!item.children?.length;
              const key = item.label;
              const isOpen = openDropdown === `m-${key}`;

              return (
                <div key={key} className="st-mItem">
                  <div className="st-mRow">
                    <a className="st-mLink" href={item.href} onClick={() => setMobileOpen(false)}>
                      {item.label}
                    </a>

                    {hasChildren && (
                      <button
                        className="st-mToggle"
                        type="button"
                        onClick={() => toggleDropdown(`m-${key}`)}
                        aria-expanded={isOpen}
                        aria-label={`Toggle ${item.label}`}
                      >
                        {isOpen ? "−" : "+"}
                      </button>
                    )}
                  </div>

                  {hasChildren && isOpen && (
                    <div className="st-mChildren">
                      {item.children.map((c) => (
                        <a
                          key={c.href}
                          className="st-mChild"
                          href={c.href}
                          onClick={() => setMobileOpen(false)}
                        >
                          {c.label}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <div className="st-mobileBottom">
            <a className="st-mobileCart" href="/cart" onClick={() => setMobileOpen(false)}>
              🛒 View Cart
            </a>
          </div>
        </div>

        {/* overlay */}
        <button className="st-overlay" aria-label="Close overlay" onClick={() => setMobileOpen(false)} />
      </div>
    </header>
  );
}